import { frontendURL } from 'dashboard/helper/URLHelper.js';

const CampaignsPageRouteView = () =>
  import('./pages/CampaignsPageRouteView.vue');
const LiveChatCampaignsPage = () => import('./pages/LiveChatCampaignsPage.vue');
const SMSCampaignsPage = () => import('./pages/SMSCampaignsPage.vue');
const WhatsAppCampaignsPage = () => import('./pages/WhatsAppCampaignsPage.vue');
const WahaCampaignsPage = () => import('waha/campaigns/WahaCampaignsPage.vue');
const WhatsAppCampaignAnalyticsPage = () =>
  import('./pages/WhatsAppCampaignAnalyticsPage.vue');
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const meta = {
  featureFlag: FEATURE_FLAGS.CAMPAIGNS,
  permissions: ['administrator'],
};

const campaignsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/campaigns'),
      component: CampaignsPageRouteView,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'campaigns_ongoing_index', params: to.params };
          },
        },
        {
          path: 'ongoing',
          name: 'campaigns_ongoing_index',
          meta,
          redirect: to => {
            return { name: 'campaigns_livechat_index', params: to.params };
          },
        },
        {
          path: 'one_off',
          name: 'campaigns_one_off_index',
          meta,
          redirect: to => {
            return { name: 'campaigns_sms_index', params: to.params };
          },
        },
        {
          path: 'live_chat',
          name: 'campaigns_livechat_index',
          meta,
          component: LiveChatCampaignsPage,
        },
        {
          path: 'sms',
          name: 'campaigns_sms_index',
          meta,
          component: SMSCampaignsPage,
        },
        {
          path: 'whatsapp',
          name: 'campaigns_whatsapp_index',
          meta: {
            ...meta,
            featureFlag: FEATURE_FLAGS.WHATSAPP_CAMPAIGNS,
          },
          component: WhatsAppCampaignsPage,
        },
        {
          path: 'waha',
          name: 'campaigns_waha_index',
          meta: {
            ...meta,
            featureFlag: FEATURE_FLAGS.WAHA_CAMPAIGNS,
          },
          component: WahaCampaignsPage,
        },
        {
          path: 'whatsapp/:campaignId/analytics',
          name: 'campaigns_whatsapp_analytics',
          meta: {
            ...meta,
            featureFlag: FEATURE_FLAGS.WHATSAPP_CAMPAIGNS,
          },
          component: WhatsAppCampaignAnalyticsPage,
        },
      ],
    },
  ],
};

export default campaignsRoutes;
